import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42mXKwQqAIBCEYd//AYNuESEdwsR0bVu3qYsiOKef4TPolnxEdKG/imklBXZesU0LhGUE+SL43eG0ByikEbyqeDKD6Yb+XcEHUQZ9bR9XGdUAAAAASUVORK5CYII="};
